<script>
    import {replace} from 'svelte-spa-router'
    import {fade} from 'svelte/transition'

    let clientCode;

    firebase.firestore().doc("users/" + firebase.auth().currentUser.uid).onSnapshot(docSnapshot => {
        if (docSnapshot.data().client !== undefined)
            replace('/equipment');
    })

    function save() {
        firebase.firestore().doc("users/" + firebase.auth().currentUser.uid).set({
            client: clientCode
        }, {merge: true});
    }
</script>

<style>
    .login-clean {
        max-width: 500px;
        width: 90%;
        margin: 0 auto;
        background-color: #ffffff;
        padding: 40px;
        border-radius: 4px;
        box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1);
    }
</style>

<br>

<div class="login-clean" transition:fade="{{duration: 200}}">
    <h1>Company Selection</h1>
    <p>Please use the company code you received in order to finalize your account</p>
    <div class="form-group">
        <input class="form-control" name="company code" placeholder="Company code" bind:value={clientCode}/>
    </div>
    <div class="form-group">
        <button class="btn btn-primary btn-block" type="button" on:click={save}>Ok</button>
    </div>
    <div class="forgot">You can also contact your system admin.</div>
</div>


